export default __webpack_public_path__ + "static/media/barlow-condensed.bold.a2df3d33.ttf";